import gql from 'graphql-tag'

export default gql`mutation go($data: ClientInput!){
  upsertClient(data: $data){
    client_id
  }
}`